<template>
    <div>
        <div class="brdr_box_w_checkbox">
            <label class="switch_checkbox_item">
                <input type="checkbox" :checked="appConfig['detect_country']" @change="$emit('update', $event.target.checked, 'detect_country')">
                <div class="switch_checkbox"><span></span></div>
            </label>
            <h3>Auto select a currency based on customer's location?
                <info-icon>
                        <b>Smart Currency Converter</b> will <u>auto-detect</u> your customers' location and try to select a currency by default.<br>
                        Your customers will be allowed to select a different currency if they wish.
                </info-icon>
            </h3>
        </div>

        <div class="brdr_box_w_checkbox">
            <label class="switch_checkbox_item">
                <input type="checkbox" :checked="appConfig['detect_entered_address']" @change="$emit('update', $event.target.checked, 'detect_entered_address')">
                <div class="switch_checkbox"><span></span></div>
            </label>
            <h3>Auto select a currency based on customers' entered billing/shipping address?
                <info-icon>
                        <p><b>Smart Currency Converter</b> will select a currency based on the billing or shipping address entered by your customers in your order form.</p>
                </info-icon>
            </h3>
        </div>

        <p class="info-message">Billing address will always take precedence over a shipping address if exists.</p>

        <div class="brdr_box_w_checkbox">
            <label class="switch_checkbox_item">
                <input type="checkbox" :checked="appConfig['round_prices']" @change="$emit('update', $event.target.checked, 'round_prices')">
                <div class="switch_checkbox"><span></span></div>
            </label>
            <h3>Round prices?
	            <info-icon>
		            Rounds any prices above $1 (or other currencies' equivalent) to the nearest integer.
	            </info-icon>
            </h3>
        </div>

	    <div class="brdr_box_w_checkbox">
		    <label class="switch_checkbox_item">
			    <input type="checkbox" :checked="appConfig['auto_detect_prices']" @change="$emit('update', $event.target.checked, 'auto_detect_prices')">
			    <div class="switch_checkbox"><span></span></div>
		    </label>
		    <h3>Auto-localize prices on your entire funnel?
			    <info-icon>
				    Smart currency will attempt to automatically localize any prices on your entire funnel,
				    wherever a price is mentioned Smart currency will convert it to the appropriate local currency when possible.<br/><br/>
				    Works best when <b>Auto select a currency based on customer's location?</b> is also selected.
			    </info-icon>
		    </h3>
	    </div>

	    <div class="brdr_box_w_checkbox">
		    <label class="switch_checkbox_item">
			    <input type="checkbox" :checked="appConfig['show_currency_popup']" @change="$emit('update', $event.target.checked, 'show_currency_popup')">
			    <div class="switch_checkbox"><span></span></div>
		    </label>
		    <h3>Show a currency popup on your entire funnel?
			    <info-icon>
				    Smart currency will show a popup on all your funnel steps allowing your
				    customers to change their preferred currency if they wish.
				    <img :src="require('@/assets/img/smart-currency-popup.png')" height="50px" style="margin-top: 5px;"  />
			    </info-icon>
		    </h3>
	    </div>

    </div>
</template>

<script>
import Tooltip from "@/components/Tooltip.vue"
import InfoIcon from "@/components/base/info-icon";
import VSwitch from "@/components/base/v-switch";
export default {
    name: 'SmartCurrency',
    props: ['dataBufferObject'],
    components: {
	    VSwitch,
	    InfoIcon,
        Tooltip
    },
    data() {
        return {
            appConfig: {}
        }
    },
    created(){
        if(this.dataBufferObject) {
            this.appConfig = this.dataBufferObject;
        } else {
            this.appConfig = JSON.parse("{\"detect_country\":false,\"detect_entered_address\":false,\"round_prices\":false}");
        }
    }
}
</script>
